;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { buildQueryParams } from '@workspace/ui/lib';
import fetchAPI from '@/lib/fetch-api';
import type { Contractor } from '@/types/contractor';

export const getContractorByUserId = async (
  userId: number,
  organisationId?: number
): Promise<Contractor> => {
  const queryParams = buildQueryParams({
    user_id: userId,
    organisation_id: organisationId,
  });

  const response = await fetchAPI<Contractor>(
    `${process.env.NEXT_PUBLIC_EOR_API_URL}/contractors/by-user-id?${queryParams.toString()}`,
    {
      method: 'GET',
    }
  );

  if (!response.success && (!response.status || ![200, 201].includes(response.status))) {
    throw new Error(response.error || response.message || 'Failed to fetch contractor');
  }

  if (!response.data) {
    throw new Error('Contractor not found');
  }

  return response.data;
};
